import React from "react";

import Input from "components/input";
import CheckBoxGroup from "components/checkBoxGroup";
import RadioGroup from "components/radioGroup";
import Rating from "components/rating_feedback";
import TextArea from "components/textarea";

import { QUESTION_TYPES } from "components/feedback-framework/constants/feedback.constants";
import styles from "./question.scss";

const { RATING, SINGLE_SELECT, MULTI_SELECT, TEXT_INPUT, TEXT_AREA } = QUESTION_TYPES;

const CustomRating = ({ id, ratingRange, answer, setAnswer }) => {
	return <Rating options={ratingRange} rating={answer} setRating={(rating) => setAnswer(id, RATING, rating)} />;
};

const CustomSingleSelect = ({ id, options, answer, setAnswer }) => {
	return (
		<RadioGroup
			options={options}
			value={answer}
			getKey={(option) => option?.code}
			getName={(option) => option?.label}
			onChange={(option) => setAnswer(id, SINGLE_SELECT, option)}
		/>
	);
};

const CustomMultiSelect = ({ id, options, answer, setAnswer }) => {
	return (
		<CheckBoxGroup
			options={options}
			value={answer}
			getKey={({ code }) => code}
			getName={({ label }) => label}
			onChange={(option) => setAnswer(id, MULTI_SELECT, option)}
		/>
	);
};

const CustomInput = ({ id, placeholder, answer = "", setAnswer }) => {
	return (
		<Input placeholder={placeholder} required value={answer} onChange={(value) => setAnswer(id, TEXT_INPUT, value)} />
	);
};

const CustomTextArea = ({ id, placeholder, maxLength = 200, answer = "", setAnswer }) => {
	return (
		<TextArea
			placeholder={placeholder}
			required
			value={answer}
			onChange={(value) => setAnswer(id, TEXT_AREA, value)}
			maxLength={maxLength}
			rows="4"
		/>
	);
};

const TYPE_TO_COMPONENT_MAP = {
	[RATING]: {
		component: CustomRating,
	},
	[SINGLE_SELECT]: {
		component: CustomSingleSelect,
		bottomText: "Select one",
	},
	[MULTI_SELECT]: {
		component: CustomMultiSelect,
		bottomText: "Select one or many",
	},
	[TEXT_INPUT]: {
		component: CustomInput,
	},
	[TEXT_AREA]: {
		component: CustomTextArea,
	},
};

const Question = ({ questionConfig, onQuestionAnswered }) => {
	const { inputType, statement, mandatory, ...otherProps } = questionConfig;
	const { component:Component, bottomText } = TYPE_TO_COMPONENT_MAP[inputType];

	return (
		<section className={styles.feedback_question}>
			<div className={styles.question_heading}>
				<h3 className={styles.question_title}>
					{statement}
					{!mandatory && <span className={styles.optional_label}>Optional</span>}
				</h3>
			</div>
			<div className={styles.question_content}>
				<Component setAnswer={onQuestionAnswered} {...otherProps} />
				{bottomText && <div className={styles.small_gray}>{bottomText}</div>}
			</div>
		</section>
	);
};

export default Question;
